import Chip, {ChipProps} from '@mui/material/Chip';
import Tooltip from '@mui/material/Tooltip';
import dayjs from 'dayjs';
import {ReactNode} from 'react';

import {Account} from '@pages/pilotage-rh/accounts/account-types';

export type subscriptionStatus =
  | 'SUBSCRIPTION_TRIAL'
  | 'SUBSCRIPTION_PAID'
  | 'SUBSCRIPTION_EXPIRED'
  | 'SUBSCRIPTION_NONE';

export const subscriptionStatusOptions: {value: subscriptionStatus; label: string; color: ChipProps['color']}[] = [
  {value: 'SUBSCRIPTION_NONE', label: 'Aucun', color: 'default'},
  {value: 'SUBSCRIPTION_TRIAL', label: 'Trial', color: 'info'},
  {value: 'SUBSCRIPTION_PAID', label: 'Abonné', color: 'success'},
  {value: 'SUBSCRIPTION_EXPIRED', label: 'Expirée', color: 'warning'},
];

type SubscriptionStatusProps = Omit<ChipProps, 'size'> & {
  account: Account;
};

export const SubscriptionStatus = ({account, ...props}: SubscriptionStatusProps) => {
  const subscriptionChips: ReactNode[] = [];
  account.subscriptions.forEach((subscription) => {
    const expirationDate = dayjs(subscription.expiresAt).format('DD/MM/YYYY');
    const option = subscriptionStatusOptions.find((option) => option.value === subscription.code);
    subscriptionChips.push(
      <Tooltip
        key={subscription.service + subscription.code}
        title={`${option?.label} jusqu'au ${expirationDate}`}
        arrow
      >
        <Chip sx={{mr: 1}} label={subscription.service} size="small" variant="soft" color={option?.color} {...props} />
      </Tooltip>,
    );
  });

  return <>{subscriptionChips}</>;
};
